import { useCallback, useLayoutEffect, useMemo } from 'react';

/** Invalidate asynchronous UI work when leaving an order, even on A -> B -> A. */
export const useOrderVisit = (orderId: string) => {
  const visit = useMemo(() => ({ active: false }), [orderId]);
  useLayoutEffect(() => {
    visit.active = true;
    return () => {
      visit.active = false;
    };
  }, [visit]);
  return useCallback(() => visit.active, [visit]);
};
